import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import method from '../../utils/piwik/method';
/**
 * `EventRoute` wraps React Router's [Route](https://reacttraining.com/react-router/web/api/Route)
 * and logs a Piwik pageview whenever the user navigates to it.
 *
 * @public
 * @author Connor Taylor
 */

var EventRoute =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(EventRoute, _Component);

  function EventRoute() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackPageView", function () {
      method("setDocumentTitle", [document.title]);
      method("setCustomUrl", [window.location.pathname + window.location.search]);
      method("trackPageView", []);
    });

    return _this;
  }

  var _proto = EventRoute.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.trackPageView();
  }; // Handle the case where the same route is rendered again, but with different
  // params


  _proto.componentDidUpdate = function componentDidUpdate() {
    this.trackPageView();
  };

  _proto.render = function render() {
    return React.createElement(Route, this.props);
  };

  return EventRoute;
}(Component);

export { EventRoute as default };